import React from "react";
import PropTypes from "prop-types";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSelector, useDispatch } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { logout } from "../../actions/app";
import { ROOT_PAGE_PATH } from "../../routes/path";
import Logo from "../../assets/logo/logo_blanco.png";

const Header = ({ onShow }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer.user);
  const token = useSelector((state) =>
    Boolean(state.appReducer.token.accessToken)
  );
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleLogout = () => {
    handleMenuClose();
    dispatch(logout());
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "#303C54",
      }}
    >
      <Toolbar>
        {token && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={onShow}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Box
          component={RouterLink}
          to={ROOT_PAGE_PATH}
          sx={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "inherit",
            flexGrow: 1,
          }}
        >
          <Box
            component="img"
            src={Logo}
            alt="Visor MAPX"
            sx={{ height: 40, mr: 1 }}
          />
          {isDesktop && <Typography variant="h6" noWrap></Typography>}
        </Box>

        {token && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <AccountCircleIcon />
            {isDesktop && (
              <Typography variant="body1" sx={{ mx: 1 }}>
                {user?.nombre}
              </Typography>
            )}
            <IconButton color="inherit" onClick={handleMenuOpen}>
              <ArrowDropDownIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={handleLogout}>Cerrar Sesión</MenuItem>
            </Menu>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  onShow: PropTypes.func.isRequired,
};

export default Header;
